import React from "react";
import { useNavigate } from "react-router-dom";
import { LockedFeaturePage as SharedLockedFeaturePage } from "../../../../../shared/frontend/billing/LockedFeaturePage";
import type { FeatureTeaserData } from "../../../../../shared/frontend/billing/featureLockTypes";
import { useFeatureAccess } from "../app/auth/useFeatureAccess";
import { useI18n } from "../app/i18n/useI18n";

export type LockedFeaturePageProps = {
  capabilityKey: string;
};

export function LockedFeaturePage({ capabilityKey }: LockedFeaturePageProps) {
  const { text } = useI18n();
  const nav = useNavigate();
  const access = useFeatureAccess(capabilityKey);

  const feature: FeatureTeaserData = {
    title: text(access.metadata.title),
    description: text(access.metadata.description),
    badgeText: text(access.metadata.badgeText),
    highlights: access.metadata.highlights?.map((h) => text(h)),
    upgradeUrl: access.upgradeUrl,
    planName: access.metadata.planName ? text(access.metadata.planName) : undefined,
    planPriceText: access.metadata.planPriceText ? text(access.metadata.planPriceText) : undefined,
    addonName: access.metadata.addonName ? text(access.metadata.addonName) : undefined,
    addonPriceText: access.metadata.addonPriceText ? text(access.metadata.addonPriceText) : undefined,
    tariffNotice: text({
      de: "In der Tarifverwaltung unter Abrechnung können Sie Ihren Tarif wechseln oder einzelne Optionen direkt zubuchen.",
      en: "In billing settings, you can change your plan or book individual options directly."
    }),
  };

  return (
    <SharedLockedFeaturePage
      feature={feature}
      onBack={() => nav(-1)}
      onUpgrade={() => nav(access.upgradeUrl)}
      upgradeLabel={text({ de: "zur Tarifauswahl", en: "to plan selection" })}
      backLabel={text({ de: "zurück", en: "back" })}
      benefitsTitle={text({
        de: "im Modul enthalten:",
        en: "Included with this module:",
      })}
    />
  );
}
